import { Box as RebassBox } from 'rebass/styled-components';
import styled from 'styled-components';
import { background, border, compose, position } from 'styled-system';

import type {
  BackgroundSystemsProps,
  BorderSystemProps,
  ColorSystemProps,
  FlexboxSystemProps,
  LayoutSystemProps,
  PositionSystemsProps,
  SpacingSystemProps,
} from '../styledSystemPropTypes';

export type Props = BackgroundSystemsProps &
  BorderSystemProps &
  ColorSystemProps &
  FlexboxSystemProps &
  LayoutSystemProps &
  PositionSystemsProps &
  SpacingSystemProps & {
    as?: string;
    children?: any;
    sx?: any;
    tx?: string;
    variant?: string;
  };

const Box = styled(RebassBox)<Props>(compose(border, background, position));

export default Box;



// WEBPACK FOOTER //
// ../kibble/components/Box/Box.tsx